export default {
    name: "individualGroupable",
    props: {
        individualGroupable: Boolean,
    } as const,
    events: {} as const,
} as const;
